import React, { SyntheticEvent, useState } from 'react'

import FormHeader from '../../../../../components/Auth/FormHeader'
import FormFooter from '../../../../../components/Auth/FormFooter'
import styles from '../../../../LogIn/Components/loginComponents.module.scss'

import { BoxStyledErrorMessage } from '../../../../../components/FormElements'
import { StyledVerificationMessage } from '../../../../../components/FormElements/StyledVerificationMessage'
import { getSanitizedHtml } from '@src/quince-site-common/src/utils/getSanitizedHtml'
import { Email } from '../../../../LogIn/Components/Email'
import { Password } from '../../../../LogIn/Components/Password'
import { ContinueButton } from '../../../../LogIn/Components/ContinueButton'
import Button from '../../../../../components/Button'
import useForm from '../../../../LogIn/hook/useForm'
import { getlbUserId } from '@src/quince-site-common/src/utils/getlb-user-id'

interface SecondaryPagePropTypes {
  serverError?: { message: string }
  unverifiedAccount?: boolean
  resendVerificationEmail: (email?: string) => void
  verificationEmailSent?: boolean
  email?: string
  backToLogin: () => void
  loading?: boolean
  login: (data: object) => void
  onEmailEdit: () => void
  isInResetPasswordFlow?: boolean
}

const SecondaryPage = ({
  serverError,
  unverifiedAccount,
  resendVerificationEmail,
  verificationEmailSent,
  email,
  backToLogin,
  loading,
  login,
  onEmailEdit,
  isInResetPasswordFlow,
}: SecondaryPagePropTypes) => {
  const [errors, setError] = useState({})
  const { email: userEmail, password, onPasswordChange, onEmailChange } = useForm({ email })
  const onFormSubmit = (e: SyntheticEvent) => {
    e.preventDefault()

    if (!password) {
      setError({
        password: {
          message: 'Please fill in Password',
        },
      })
    } else {
      login({
        password,
        username: isInResetPasswordFlow ? userEmail : email,
      })
    }
  }
  return (
    <form id="login-form-A-secondary" onSubmit={onFormSubmit} noValidate>
      <FormHeader>
        <div className={styles.formHeading}>WELCOME BACK!</div>
        <div className={styles.formSubHeading}>
          Free shipping, 365-day returns, exclusive benefits, and savings on future orders.
        </div>
      </FormHeader>
      {serverError && (
        <BoxStyledErrorMessage dangerouslySetInnerHTML={{ __html: getSanitizedHtml(serverError.message) }} />
      )}
      {unverifiedAccount && (
        <StyledVerificationMessage>
          cannot find verification mail?
          <Button
            onClick={() => {
              resendVerificationEmail(email)
            }}
            trackParams={{
              trackInternal: true,
              category: 'login',
              action: 'account_login_unverified',
              context: {
                login_email: email || '',
                lb_user_id: getlbUserId(),
              },
            }}
            className={styles.unVerifiedMessage}
          >
            resend one
          </Button>
        </StyledVerificationMessage>
      )}
      {verificationEmailSent && <StyledVerificationMessage>Verification E-mail Sent!</StyledVerificationMessage>}

      <Email
        errors={errors}
        disabled={!isInResetPasswordFlow}
        value={userEmail}
        onChange={isInResetPasswordFlow ? onEmailChange : undefined}
        onEdit={onEmailEdit}
        showEditIcon={!isInResetPasswordFlow}
      />
      <Password
        errors={errors}
        email={email}
        backToLogin={backToLogin}
        value={password}
        onChange={onPasswordChange}
        isInResetPasswordFlow={isInResetPasswordFlow}
      />
      <FormFooter>
        <ContinueButton loading={loading} form="login-form-A-secondary" />
      </FormFooter>
    </form>
  )
}

export { SecondaryPage }
